import React, { Component } from 'react';
import ProductRow from './ProductRow'; 
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { auth } from '../firebase';

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchProducts();
  }

  fetchProducts = async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        const db = getFirestore();
        const productsRef = collection(db, 'products');
        const q = query(productsRef, where('userId', '==', user.uid)); 
        const querySnapshot = await getDocs(q);
        const productsList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.setState({ products: productsList });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des produits:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { products, loading } = this.state;

    if (loading) {
      return <div>Chargement...</div>; 
    }

    return (
      <div style={styles.container}>
        <h2 style={styles.title}>Mes Articles</h2>
        <table className="table" style={styles.table}>
          <thead>
            <tr style={styles.header}>
              <th style={styles.headerCell}>Photo</th>
              <th style={styles.headerCell}>Nom</th>
              <th style={styles.headerCell}>Prix</th>
              <th style={styles.headerCell}>État</th>
            </tr>
          </thead>
          <tbody>
            {products.length === 0 ? (
              <tr>
                <td colSpan="4" style={styles.cell}>Aucun article trouvé</td>
              </tr>
            ) : (
              products.map((product) => (
                <ProductRow
                  key={product.id}
                  image={product.productImage || 'https://via.placeholder.com/150'}
                  name={product.productName}
                  price={product.price}
                  status={product.productCondition || 'Available'} 
                />
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const styles = {
  container: {
    marginTop:'100px',
    width:'80%',
    padding: '30px',
    backgroundColor: '#f1f1f1',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  title: {
    textAlign: 'center',
    margin: '30px 0',
    color: '#1e1e1e',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '2.5em',
    fontWeight: '700',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '30px',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '1rem',
  },
  header: {
    backgroundColor: '#343a40',
  },
  headerCell: {
    padding: '15px',
    textAlign: 'center',
    fontSize: '1.2em',
    fontWeight: '600',
    borderBottom: '2px solid #dee2e6',
  },
  cell: {
    padding: '15px',
    textAlign: 'center',
    borderBottom: '1px solid #dee2e6',
  },
};

export default Product;
